// src/pages/ReviewerHome.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import SubmissionList from "../components/E2E/SubmissionList";

function ReviewerHome() {
  return (
    <div>
      <main>
        <SubmissionList />
      </main>
    </div>
  );
}

export default ReviewerHome;